import { queryOptions } from "@tanstack/react-query";
import { gql } from "graphql-request";

import { gqlClient } from "../../../shared/lib/gql-client";
import type { Tag } from "../types";

const TAGS = gql`
  query Tags {
    tags {
      id
      slug
      label
    }
  }
`;

export const tagQueries = {
  all: () => ["tags"] as const,
  list: () =>
    queryOptions({
      queryKey: [...tagQueries.all(), "list"] as const,
      queryFn: () => gqlClient.request<{ tags: Tag[] }>(TAGS),
      /*
       * A curated vocabulary changes on the order of never — refetching it on
       * every focus would spend a round trip to learn nothing. Invalidated
       * explicitly by createTag/deleteTag instead.
       */
      staleTime: Infinity,
    }),
};
